import * as yup from 'yup';

export const jvmAutoInstrumentValidationSchema = yup.boolean().required();
